import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {Term} from "../../models/communication-terms";

@Component({
    selector: 'app-view-privacy-dialog',
    templateUrl: './view-privacy-dialog.component.html',
    styleUrls: ['./view-privacy-dialog.component.css'],
    standalone: false
})
export class ViewPrivacyDialogComponent implements OnInit {

  allConditionsSelected: boolean = false;
  requiredCondCount: number = 0;
  terms: Term[] = [];

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<ViewPrivacyDialogComponent>,
      private nav: NavBarComponent
  ) {
  }

  ngOnInit(): void {
    this.terms = this.data.terms;
    this.nav.toggleLoading(false);
    for(let term of this.terms) {
      if(term.shouldAccept) {
        if(!term.accepted && !term.acceptedDate) {
          this.requiredCondCount++
        }
        term.text = '(Required) ' + term.text;
      } else {
        term.text = '(Optional) ' + term.text;
      }
    }
  }

  checkSelectedConditions() {
    let selectedCount = 0;
    for(let term of this.terms) {
      if(term.shouldAccept && term.accepted && !term.acceptedDate) {
        selectedCount++;
      }
    }

    this.allConditionsSelected = selectedCount === this.requiredCondCount;
  }

  closeDialog(allSelected?: boolean) {
    this.dialogRef.close(allSelected ? this.terms : null);
  }

}
